"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paypalOnShippingChange = void 0;
const src_1 = require("..");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function paypalOnShippingChange(data, actions) {
    return __awaiter(this, void 0, void 0, function* () {
        const { shipping_address: address, selected_shipping_option: selectedOption } = data;
        const { reject, order: { patch: unCastedPatch } } = actions;
        const { MAX_STRING_LENGTH: maxStringSize } = src_1.paypalConstants;
        const patch = unCastedPatch;
        if (address) {
            const formattedAddress = (0, src_1.formatPaypalToApiAddress)(address);
            const success = true;
            const shippingAddressResponse = yield (0, src_1.callShippingAddressEndpoint)(formattedAddress, true);
            if (!shippingAddressResponse.success) {
                return reject();
            }
            if (success) {
                const shippingLinesResponse = yield (0, checkout_frontend_library_1.getShippingLines)(src_1.API_RETRY);
                const { selected_shipping: selectedShipping, available_shipping_lines: shippingLines } = (0, checkout_frontend_library_1.getShipping)();
                if (shippingLinesResponse.success) {
                    if (selectedOption) {
                        const option = shippingLines.find(line => (0, src_1.isSimilarStrings)(line.description.substring(0, maxStringSize), selectedOption.label));
                        option && (yield (0, checkout_frontend_library_1.changeShippingLine)(option.id, src_1.API_RETRY));
                    }
                    else if (!selectedShipping && shippingLines.length > 0) {
                        yield (0, checkout_frontend_library_1.changeShippingLine)(shippingLines[0].id, src_1.API_RETRY);
                    }
                    yield (0, checkout_frontend_library_1.getShippingLines)(src_1.API_RETRY);
                }
            }
        }
        const taxResponse = yield (0, checkout_frontend_library_1.setTaxes)(src_1.API_RETRY);
        if (taxResponse.success) {
            const patchOperations = (0, src_1.getPaypalPatchOperations)(!!selectedOption);
            return yield patch(patchOperations);
        }
        return reject();
    });
}
exports.paypalOnShippingChange = paypalOnShippingChange;
